module.exports = __webpack_public_path__ + "static/media/LowerRoswell_7.6a725b4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/LowerRoswell_7.jpg
// module id = 474
// module chunks = 0